import { GET_PRIMARY_APPROVER, SET_PRIMARY_APPROVER } from "./PrimaryApproverType";

const getPrimaryApprover = (val: any, typeVal: any) => ({
    type: GET_PRIMARY_APPROVER,
    val, typeVal
});

const setPrimaryApprover = (primaryApproverList: any) => ({
    type: SET_PRIMARY_APPROVER,
    primaryApproverList
});

export {
    getPrimaryApprover,
    setPrimaryApprover
}
